var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSortMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3392 9.45728C6.18253 9.70795 5.81747 9.70795 5.6608 9.45728L1.3825 2.612C1.21599 2.34558 1.40753 2 1.7217 2L10.2783 2C10.5925 2 10.784 2.34558 10.6175 2.612L6.3392 9.45728Z",
    fill: "#9D9D9D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSortMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sort-mark.e4c7687a.svg";
export { ForwardRef as ReactComponent };